export const GET_PRIVACY_POLICY_PENDING = 'GET_PRIVACY_POLICY_PENDING';
export const GET_PRIVACY_POLICY_FULFILLED = 'GET_PRIVACY_POLICY_FULFILLED';
export const GET_PRIVACY_POLICY_REJECTED = 'GET_PRIVACY_POLICY_REJECTED';

export default (state = {
  content: '',
  fetching: false,
  fetched: false,
  errors: {}
}, action) => {
  switch (action.type) {
    case GET_PRIVACY_POLICY_PENDING: {
      return {...state, fetching: true, fetched: false};
    }
    case GET_PRIVACY_POLICY_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        content: action.payLoad,
      };
    }
    case GET_PRIVACY_POLICY_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
      };
    }
    default: return {...state};
  }
};
